import "../styles/globals.css";
import "../styles/modal.css";
import "../styles/parallax.css";
import "../styles/internal/customTailwind.css";

import type { AppProps } from "next/app";

function MyApp({ Component, pageProps }: AppProps) {
  return <Component {...pageProps} />;
}

export default MyApp;
